module.exports = __webpack_public_path__ + "static/Sports-0e148df1cc124a5842648b3e652d5170.png";